import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';

export const readCampaign = async <T extends Record<string, unknown>>({
  campaignId,
  headers,
  domain,
  query,
}: FetchRequestArgs & { campaignId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    domain,
    endpoint: `/campaigns/${campaignId}`,
    headers,
    query,
  });
